import type { PropsWithChildren } from "react";

import NoticeModals from "src/components/notices/NoticeModals";
import NoticeProvider from "src/components/providers/notices/NoticeProvider";
import { ApplicationLayoutMode } from "src/contexts/preferences/UserPreferencesContext";
import useUserPreferences from "src/hooks/preferences/useUserPreferences";

import LegacyLayout from "./legacy/DefaultLayout";
import ModernLayout from "./modern/DefaultLayout";

/**
 * Selects the preferred layout inside a shared notice provider and includes notice modals.
 *
 * Postconditions: Modern is selected only for the modern preference; other values use legacy.
 * Notice modals share the same provider regardless of the selected layout.
 */
const ApplicationLayout = ({ children }: PropsWithChildren) => {
    const { preferences } = useUserPreferences();

    return (
        <NoticeProvider>
            {preferences.layout === ApplicationLayoutMode.Modern ? (
                <ModernLayout>{children}</ModernLayout>
            ) : (
                <LegacyLayout>{children}</LegacyLayout>
            )}
            <NoticeModals />
        </NoticeProvider>
    );
};

export default ApplicationLayout;
